import { Box, Button, CardContent, Checkbox, CircularProgress, Divider, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Select, TextField, Tooltip, Typography } from '@material-ui/core';
import useCustomModal from 'components/CustomConfirm';
import CustomConfirmDialog from 'components/CustomConfirm/CustomConfirmDialog';
import moment from "moment-timezone";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { cancelBooking, confirmBooking, createNewBooking, getVerifiedSchedules, updateWhitelabelBookingDate } from 'services/booking.service';
import { getDefaultPaymentMethod } from 'services/payments.service';
import { isEmpty } from 'lodash';
import { DatePicker } from './StaticCalendar';

import { filterNonNull } from '@zennya/web-component-library/src/components/SegmentIO';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { isPayable, parseBookingStatus } from 'util/bookingStates';
import { useTrackEvent } from 'util/trackEvent';
import { adjustTransactionState, bookingState, isWaitingForPollState, manualRefreshState, rebookedState } from '../RecoilState';
import { toast } from 'react-hot-toast';
import { Alert } from '@material-ui/lab';
import { useUpdateEffect } from 'usehooks-ts';
import { timeSlotState } from 'pages/CustomerBookingCreate/state';
import ReactJson from 'react-json-view';
import { toasterror } from 'util/toasterror';

const useStyles = makeStyles((theme) => {
  return {
    action: {
      '& > *': {
        marginRight: theme.spacing(2),
      }
    },
    padded: {
      paddingBottom: theme.spacing(2)
    },
    buttonPad: {

    },
    leftSlot: {

    },
    dialogContent: {
      '& > *': {
        marginBottom: theme.spacing(2)
      }
    },
    warning: {
      marginTop: theme.spacing(6)
    },
    disabledSlotText: {
      textDecoration: 'line-through',
    },
    highlyAvailableSlotText: {
      color: theme.palette.primary.main,
      fontWeight: 'bold'
    },
    regularSlotText: {
      color: theme.palette.text.primary,
      fontWeight: 'regular'
    },
    availableSlotText: {
      color: theme.palette.warning.dark,
      fontWeight: 'bold'
    },
    disabledSlotIcon: {
      display: 'none'
    },
    highlyAvailableSlotIcon: {
      color: theme.palette.success.main,
    },
    regularSlotIcon: {
      color: 'transparent',
    },
    timeslotContainer: {
      '&>*': {
        width: '100%'
      }
    },
    highlyAvailableOnlyCheck: {
      ...theme.typography.caption
    }
  }
})


const Timeslot = ({ booking_id, times: slots, onSelect, preferredBookingDate }) => {
  const classes = useStyles()
  const [slot, setSlot] = useState('');

  const trackEvent = useTrackEvent()

  useEffect(() => {
    onSelect(slot)
  }, [onSelect, slot]);


  const [highAvailiabilityOnly, setHighAvailiabilityOnly] = useState(false);
  const getStatusClass = useCallback(
    (slot) => {
      const now = moment()
      const std = moment(slot?.start_date_time)
      const diff = std.diff(now, 'hours')
      const maxCutoff = diff > parseInt(process.env.REACT_APP_BOOKING_CUTOFF ?? 0)

      // if (!maxCutoff) {
      //   return { icon: classes.disabledSlotIcon, text: classes.disabledSlotText }
      // }
      if (moment(preferredBookingDate).diff(moment(), 'days') >= 5) {
        return { icon: classes.regularSlotIcon, text: classes.regularSlotText }
      }
      switch (slot?.status) {
        case 'NOT_AVAILABLE':
          return {
            icon: classes.disabledSlotIcon,
            toolTip: 'Not Available',
            text: classes.disabledSlotText
          }
        case 'AVAILABLE':
          return {
            icon: classes.availablerSlotIcon,
            toolTip: 'Average Provider Availability',
            text: classes.availablerSlotText
          }
        case 'HIGHLY_AVAILABLE':
          return {
            icon: classes.highlyAvailableSlotIcon,
            toolTip: "High Provider Availability",
            text: classes.highlyAvailableSlotText
          }
        default:
          break;
      }
    },
    [classes.disabledSlot, classes.highlyAvailableSlot],
  );

  const availableSlots = useMemo(
    () => {
      if (moment(preferredBookingDate).diff(moment(), 'days') >= 5 || !highAvailiabilityOnly) {
        return slots
      }
      return slots?.filter(x => x?.status === 'HIGHLY_AVAILABLE')
    }, [highAvailiabilityOnly, slots]
  );
  const isSlotDisabled = useCallback(
    (slot) => {
      const now = moment()
      const std = moment(slot?.start_date_time)
      const diff = std.diff(now, 'hours')
      const maxCutoff = diff > parseInt(process.env.REACT_APP_BOOKING_CUTOFF ?? 0)
      // return slot?.status === 'NOT_AVAILABLE' || !maxCutoff
      return slot?.status === 'NOT_AVAILABLE'
    },
    [],
  );

  return (
    <FormControl fullWidth>
      <TextField
        variant='outlined'
        SelectProps={{
          MenuProps: {
            variant: "menu",
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                maxHeight: '50vh'
              }
            }
          }
        }}
        select
        fullWidth
        size="small"
        label="Available Time Slots*"
        placeholder="Select time"
        InputLabelProps={{ shrink: true }}
        value={slot}
        onChange={event => {
          trackEvent('Reschedule - time selected ', { date: event.target.value })
          setSlot(event.target.value)
        }}
      >
        {availableSlots?.map((slot, idx) => {
          const slotStyle = getStatusClass(slot)
          return (
            <MenuItem
              key={idx}
              fullWidth
              disabled={isSlotDisabled(slot)}
              className={classes.timeslotContainer}
              value={slot?.start_date_time}
            >
              <Tooltip
                title={slotStyle?.toolTip}
              >
                <Typography className={slotStyle?.text} variant="body2" color="textSecondary">
                  {moment(slot?.start_date_time).format('LT')}
                </Typography>
              </Tooltip>
            </MenuItem>
          )
        })}
      </TextField>
      <FormControlLabel
        classes={{
          label: classes.highlyAvailableOnlyCheck
        }}
        control={
          <Checkbox
            checked={highAvailiabilityOnly}
            onChange={() => {
              trackEvent(`Reschedule - timeslot - highly available only - ${highAvailiabilityOnly ? 'off' : 'on'}`)
              setHighAvailiabilityOnly(!highAvailiabilityOnly)
            }}
          />
        }
        label="High Availability Only"
      />
    </FormControl>
  )
}

const TimeslotsV2 = ({
  autoConfirm = false,
  view,
  asNewTimeslot = false,
  inline = false,
  maxDate = moment().add(1, 'y').toDate(),
  minDate,
  rebook = false, serviceId, onConfirm = () => { }, oldTime }) => {
  const classes = useStyles()
  const history = useHistory()
  const setManualRefreshState = useSetRecoilState(manualRefreshState);
  const [isWaitingForPoll, setIsWaitingForPoll] = useRecoilState(isWaitingForPollState);
  const confirm = useCustomModal()
  const [dateTime, setDateTime] = useState();
  const [errorBlock, setErrorBlock] = useState(false);
  const booking = useRecoilValue(bookingState);
  const [preferredDate, setPreferredDate] = useState(null);

  const trackEvent = useTrackEvent()
  const [adjustTransaction, setAdjustTransaction] = useRecoilState(adjustTransactionState);
  const [loading, setLoading] = useState(false);
  const [slots, setSlots] = useState([]);
  const mapSlots = useMemo(() => {
    const mappedTimes = (slots ?? []).reduce((acc, slot) => {
      const date = moment(slot?.start_date_time).format('ddd LL')
      const time = moment(slot?.start_date_time).format('LT')
      const timeArray = acc[date] || []
      timeArray?.push({ time, slot })
      acc[date] = timeArray
      return acc
    }, {})

    return Object.entries(mappedTimes)

  }, [slots]);

  const [date, setDate] = useState(null);
  const [timeSlot, setTimeSlot] = useRecoilState(timeSlotState);
  const [timeSlots, setTimeSlots] = useState([]);


  const getStatusClass = useCallback(
    (slot) => {
      switch (slot?.status) {
        case 'NOT_AVAILABLE':
          return {
            icon: classes.disabledSlotIcon,
            toolTip: 'Not Available',
            text: classes.disabledSlotText
          }
        case 'AVAILABLE':
          return {
            icon: classes.availablerSlotIcon,
            toolTip: 'Average Provider Availability',
            text: classes.availablerSlotText
          }
        case 'HIGHLY_AVAILABLE':
          return {
            icon: classes.highlyAvailableSlotIcon,
            toolTip: "High Provider Availability",
            text: classes.highlyAvailableSlotText
          }
        default:
          break;
      }
    },
    [classes.disabledSlot, classes.highlyAvailableSlot],
  );

  const fetchSchedules = useCallback(
    async () => {
      try {
        setLoading(true)
        setErrorBlock(false)
        //TODO: verify if all requests here are of type BookingSchedule
        const targetBooking = booking
        const shouldCheckForMedicalId = false
        const shouldCheckForScreening = true

        const paymentToken = await getDefaultPaymentMethod()

        const extendedPackageItems = targetBooking?.extended_package_items?.map(item => item?.item?.id)
        const extendedPackages = targetBooking?.extended_packages?.map(item => item?.package?.id)

        let rescheduleParams = {
          "should_check_for_medical_id": shouldCheckForMedicalId,
          "address": targetBooking?.user_location?.address,
          "notes": targetBooking?.user_location?.notes,
          "lng": targetBooking?.longitude,
          "payment_method_token": paymentToken?.token,
          "client_type": "web",
          "should_check_for_screening": shouldCheckForScreening,
          "lat": targetBooking?.latitude,
          "location_id": targetBooking?.user_location?.id,
          "booking_option": targetBooking?.booking_option,
          "type": targetBooking?.type?.id,
          "extended_package_items": extendedPackageItems,
          "extended_packages": extendedPackages,
          "gender": targetBooking?.gender,
          "service_addon_order": targetBooking?.service_addon_order,
          "duration": targetBooking?.duration,
          "should_check_for_payment": false,
          // "date_scheduled": moment(preferredDate).startOf('day').toDate().toISOString(),
          "wlp_id": targetBooking?.white_label_partner?.id,
          "should_check_high_availability": true,
          "white_label_customer": targetBooking?.white_label_customer?.id,
        }
        if (rebook) {
          rescheduleParams = {
            ...rescheduleParams,
            'old_service_request_id': targetBooking?.id,
          }
        }

        let schedulingResult = []
        schedulingResult = await getVerifiedSchedules(targetBooking?.client?.id, rescheduleParams)
        if (schedulingResult?.message) {
          const block = schedulingResult?.message?.en ?? ''
          setErrorBlock(block)
        } else {
          setSlots(schedulingResult?.verified_slots)
          mapDates(schedulingResult?.verified_slots)
        }
      } catch (error) {

      } finally {
        setLoading(false)
      }
    },
    [booking, preferredDate, rebook],
  );

  const [dates, setDates] = useState([]);
  const [times, setTimes] = useState([]);

  const mapDates = useCallback(
    (timeslots) => {
      let dts = new Set()
      timeslots?.forEach((timeslot) => {
        const dt = moment(timeslot?.start_date_time).format('YYYY-MM-DD')
        dts.add(dt)
      })
      setDates(Array.from(dts))
    },
    [],
  );

  const mapTimes = useCallback(
    (date) => {
      let tms = new Set()
      slots?.forEach((timeslot) => {
        const dt = moment(timeslot?.start_date_time).format('YYYY-MM-DD')
        if (dt === date) {
          tms.add(timeslot)
        }
      })
      setTimes(Array.from(tms))
    },
    [slots],
  );


  useEffect(
    () => {
      fetchSchedules()
    }, [booking?.id]
  );
  const [error, setError] = useState(null);

  const doReschedule = useCallback(
    async (newDateTime) => {
      try {
        setError(null)
        setIsWaitingForPoll(true)
        await updateWhitelabelBookingDate(booking?.id, newDateTime)
        setAdjustTransaction(null)


        if (isPayable(booking)) {
          // history.replace(`/bookings/${booking?.id}/payment` + history.location.search, {
          //   bookingId: booking?.id,
          //   newDateTime: newDateTime,
          // })
        } else {
          if (autoConfirm) {
            await confirmBooking(booking?.id)
          }
          history.replace(`/bookings/${serviceId}` + history.location.search)
        }
        setManualRefreshState(Math.random())
      } catch (e) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details)
        console.log("📢[index.jsx:145]: ", e);
        trackEvent(`${view} - Error`, { error: e })
      }
    },
    [autoConfirm, booking?.id, booking?.requires_payment, history, serviceId],
  );

  const setRebookedState = useSetRecoilState(rebookedState)

  const doRebook = useCallback(
    async (newDateTime) => {
      try {
        setLoading(true)
        setIsWaitingForPoll(true)
        const packages = (booking?.extended_packages ?? []).filter(x => !isEmpty(x)).map(pkg => pkg?.package?.id)
        const extended_package_items = (booking?.extended_package_items ?? []).filter(x => !isEmpty(x)).map(it => it?.item?.id)

        const parse = parseBookingStatus(booking)

        let newBookingParams = filterNonNull({
          date_scheduled: newDateTime,
          media_files: booking?.media_file_ids,
          service_addon_order: booking?.service_addon_order,
          location_id: booking?.user_location?.id,
          lat: booking?.user_location?.latitude,
          lng: booking?.user_location?.longitude,
          type: booking?.type?.id,
          booking_notes: booking?.booking_notes,
          extended_packages: packages,
          extended_package_items: extended_package_items,
          white_label_customer: booking?.white_label_customer?.id,
          wlp_id: booking?.white_label_partner?.id,
          old_service_request_id: booking?.id,
          zennya_booking_id_enabled: true,
        })

        newBookingParams = {
          ...newBookingParams,
          zennya_booking_id: booking?.zennya_booking_id,
        }

        if (booking?.requires_payment) {
          if (booking?.payment_method?.token) {
            newBookingParams = {
              ...newBookingParams,
              payment_method_token: booking?.payment_method?.token,
            }
          } else {
            history.replace(`/bookings/${booking?.id}/payment` + history.location.search, {
              bookingClientId: booking?.client?.id,
              bookingParams: newBookingParams,
              cancellable: parse?.cancellable
            })

          }
        }
        const newBooking = await createNewBooking(booking?.client?.id, newBookingParams)
        if (parse.cancellable) {
          const cancelResult = await cancelBooking(booking?.id, `SYSTEM: rebooked to ${newBooking?.id}`)
          setAdjustTransaction(null)
        }

        if (autoConfirm) {
          await confirmBooking(newBooking?.id)
        }
        setRebookedState(true)
        setLoading(false)
        setAdjustTransaction(null)
        history.replace(`/bookings/${newBooking?.id}` + history.location.search)
        setManualRefreshState(Math.random())



      } catch (e) {
        setLoading(false)
        console.log('index.jsx (151) # e', e);
        trackEvent('Rebook - Error', {
          error: {
            message: e?.message,
            message_en: e?.response?.data?.message?.en,
            details: e?.response?.data?.details,
            code: e?.response?.data?.code,
          }
        })
      }
    },
    [autoConfirm, booking?.booking_notes, booking?.client?.id, booking?.extended_package_items, booking?.extended_packages, booking?.id, booking?.media_file_ids, booking?.service_addon_order, booking?.type?.id, booking?.user_location?.id, booking?.user_location?.latitude, booking?.user_location?.longitude, booking?.white_label_customer?.id, history, setRebookedState],
  );
  const dialogTextMemo = useMemo(
    () => {
      const parse = parseBookingStatus(booking)
      return (
        <>
          <div className={classes.dialogContent}>
            {/* {rebook ? (
              <>
                <Typography>Original booking <br />{moment(oldTime).format('LL LT')} <br /></Typography>
                <Divider />
                <Typography>New booking <br />{moment(dateTime).format('LL LT')}</Typography>
              </>
            ) : ( */}
            <Typography>Change booking date from </Typography>
            <Divider />
            <Typography>{moment(oldTime).format('LL LT')} <br />to <br />{moment(dateTime).format('LL LT')}?</Typography>
            {/* )} */}
            <br />
            {(rebook && parse.cancellable) ? (
              <Typography className={classes.warning} variant="body2" color="error">Note that the status of this booking will set back to pending. Do you want to proceed?</Typography>
            ) : (
              <Typography>Do you want to proceed?</Typography>
            )}
          </div>
        </>
      )

    }, [dateTime, oldTime, rebook]
  );
  const dialogNewBookingTextMemo = useMemo(
    () => {
      const parse = parseBookingStatus(booking)
      return (
        <>
          <div className={classes.dialogContent}>
            <Typography>Set booking date to {moment(dateTime).format('LL LT')}?</Typography>
          </div>
        </>
      )

    }, [dateTime, oldTime, rebook]
  );
  const confirmProceed = useCallback(
    async () => {
      try {
        confirm(props => (
          <CustomConfirmDialog {...props}
            description={dialogTextMemo}
            title={'Confirm'}
            confirmationText='Yes'
            cancellationText='No'
            onConfirm={async () => {
              trackEvent('Reschedule - Reschedule confirmation - OK', { dialog: 'confirmProceed', date: dateTime })
              props.onClose()
              rebook ? doRebook(dateTime) : doReschedule(dateTime)
            }}
            onCancel={() => {
              trackEvent('Reschedule - Reschedule confirmation - Cancel', { dialog: 'confirmProceed' })
              props.onClose()
            }}
          />
        ))
      } catch (e) { }
    },
    [confirm, dateTime, oldTime, onConfirm],
  );

  const confirmSetNewProceed = useCallback(
    async () => {
      try {
        confirm(props => (
          <CustomConfirmDialog {...props}
            description={dialogNewBookingTextMemo}
            title={'Set your schedule'}
            onConfirm={async () => {
              trackEvent('Set new schedule confirmation - OK', { dialog: 'newScheduleconfirmProceed', date: dateTime })
              props.onClose()
              rebook ? doRebook(dateTime) : doReschedule(dateTime)
            }}
            onCancel={() => {
              trackEvent('Set new schedule confirmation - Cancel', { dialog: 'newScheduleconfirmProceed' })
              props.onClose()
            }}
          />
        ))
      } catch (e) { }
    },
    [confirm, dateTime, oldTime, onConfirm],
  );

  const renderDeadlineDate = useMemo(
    () => {
      if (asNewTimeslot) {
        const lastSlot = slots?.[slots.length - 1]
        if (!lastSlot) {
          return moment(oldTime).format("dddd LL, LTS")
        }
        return moment(lastSlot?.start_date_time).format("dddd LL")
      }
      return moment(oldTime).format("dddd LL, LTS")
    }, [slots, oldTime]
  );

  return (
    <>
      <CardContent>
        <Typography className={classes.padded} variant='body1'><b>{asNewTimeslot ? 'Deadline for booking:' : 'Original Booking:'}</b> {renderDeadlineDate}</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DatePicker
              displayStaticWrapperAs='mobile'
              showToolbar={false}
              minDate={moment().startOf('month').toDate()}
              maxDate={dates?.sort((a, b) => moment(b).diff(moment(a)))?.[0]}
              noPast
              minLimit={dates?.sort((a, b) => moment(a).diff(moment(b)))?.[0]}
              value={preferredDate}
              onChange={(newValue) => {
                const newDate = moment(newValue).format('YYYY-MM-DD')
                setPreferredDate(newDate)
                setDateTime(null)
                mapTimes(newDate)
                trackEvent(`${view} - changed date `, { date: newDate })
              }}
              label="Date*"
            />
          </Grid>
          {preferredDate && slots?.length > 0 && (
            <Grid item xs={12}>
              {slots?.length > 0 && (
                <FormControl
                  fullWidth
                  variant="outlined"
                  className={classes.formControl}
                >
                  <InputLabel id="demo-simple-select-outlined-labelTM">Time</InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-labelTM"
                    id="demo-simple-select-outlinedTM"
                    value={dateTime}
                    onChange={(e) => {
                      trackEvent('Schedule - select time')
                      setDateTime(e.target.value)
                    }}
                    label="Time"
                  >
                    {times?.map((slot, idx) => {
                      const slotStyle = getStatusClass(slot)
                      return (
                        <MenuItem
                          key={idx}
                          disabled={slot?.status === 'NOT_AVAILABLE'}
                          className={classes.timeslotContainer}
                          value={slot?.start_date_time}
                        >
                          <Tooltip
                            title={slotStyle?.toolTip}
                          >
                            <Typography className={slotStyle?.text} variant="body2" color="textSecondary">
                              {moment(slot?.start_date_time).format('LT')}
                            </Typography>
                          </Tooltip>
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              )}
            </Grid>
          )}
        </Grid>
        {errorBlock && <Alert severity="error">{errorBlock}</Alert>}
      </CardContent>
      <CardContent className={classes.action}>
        {asNewTimeslot ? (
          <>
            {dateTime && (
              <Button
                disabled={isWaitingForPoll}
                startIcon={isWaitingForPoll && <CircularProgress size={20} />}
                variant="contained" color="primary" onClick={() => {
                  trackEvent('Set new schedule - Proceed - click ', { booking_id: booking?.id })
                  confirmSetNewProceed()
                }}>Set booking time</Button>
            )}
          </>
        ) : (
          <>
            <Button
              disabled={isWaitingForPoll}
              startIcon={isWaitingForPoll && <CircularProgress size={20} />}
              variant="outlined" color="primary" onClick={() => {
                trackEvent(`${view} - Back - click `, { booking_id: booking?.id })
                history.goBack()
              }}>Back</Button>
            <Button disabled={
              isEmpty(dateTime) || isWaitingForPoll
            }
              startIcon={isWaitingForPoll && <CircularProgress size={20} />}
              variant="contained" color="primary" onClick={() => {
                trackEvent(`${view} - Proceed - click `, { booking_id: booking?.id })
                confirmProceed()
              }}>Proceed</Button>
          </>
        )}
      </CardContent>
    </>

  )
}

export { TimeslotsV2, Timeslot };
